module.exports = __webpack_public_path__ + "static/img/id003.c96455d9.jpg";